import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { fetchReqBuilderSurveysRoutine, fetchPositionLastSurveyRoutine } from '../../routines';
import { getRefReqSurveys } from '../../../../services/surveyService';
import { getLastPositionSurvey } from '../../../../services/positionService';

function* getSurveysRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getRefReqSurveys, payload);
    const data = {
      ...response,
      reset: !payload.from
    };
    yield put(fetchReqBuilderSurveysRoutine.success(data));
  } catch {
    yield put(fetchReqBuilderSurveysRoutine.failure());
  }
}

function* getLastSurveyRequest({ payload }: Routine<any>) {
  try {
    let response = null;
    if (payload) {
      const data = yield call(getLastPositionSurvey, payload);
      response = data;
    }

    yield put(fetchPositionLastSurveyRoutine.success(response));
  } catch {
    yield put(fetchPositionLastSurveyRoutine.failure());
  }
}

function* watchGetSurveysRequest() {
  yield takeEvery(fetchReqBuilderSurveysRoutine.TRIGGER, getSurveysRequest);
}

function* watchGetLastSurveyRequest() {
  yield takeEvery(fetchPositionLastSurveyRoutine.TRIGGER, getLastSurveyRequest);
}

export default function* step4Saga() {
  yield all([
    watchGetSurveysRequest(),
    watchGetLastSurveyRequest()
  ]);
}
